<template>
  <v-chip
    label
    small
  >
    {{ title }}
  </v-chip>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    title() {
      switch (this.value) {
        case 0:
          return "Банк";
        case 1:
          return "Картка";
        case 2:
          return "Готівка";
        default:
          return "";
      }
    },
  },
};
</script>
